import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService, CommonService} from 'amc-common-components';
import {AnyType} from '@entities/common/common.entity';
import {ReportApiMapper} from '../mappers/report.api.mapper';

/**
 * This class is an injectable Angular service that provides a way to fetch data..
 */
@Injectable({providedIn: 'root'})
export class ReportsApiService {
	/**
	 * Constructor for ReportsApiService.
	 */
	constructor(private apiService: ApiService) {}

	/**
	 * API method Generate Report for reports/generate_report response.
	 * @param {T | AnyType} dataParams - param for generate report.
	 * @param {U | AnyType} requestParams - param for generate report.
	 * @returns {Observable<AnyType>} - An observable that emits the generate report.
	 */
	public generateReport<T, U>(dataParams: T | AnyType, requestParams?: U | AnyType): Observable<AnyType> {
		dataParams.environmentPrefix = CommonService.getEnvironmentPrefix() || 'uat';
		return this.apiService.post('reports/generate_report', dataParams, (response) => response, {
			httpOptions: requestParams,
		});
	}

	/**
	 * API method Get Report Data for reports/get_report_data response.
	 * @param {T} dataParams - param for report data.
	 * @returns {Observable<U>} - An observable that emits the report data.
	 */
	public getReportData<T = unknown, U = unknown>(dataParams: T): Observable<U> {
		return this.apiService.post<U>('reports/get_report_data', dataParams, (resp) =>
			ReportApiMapper.mapReportData<U>(resp)
		);
	}
}
